import React from "react";
import DeliveredView from "../../views/clientView/delivered";

export default function DeliveredPage() {
    return <DeliveredView />
}